import { Hotkey } from "@tanstack/react-hotkeys";

export enum MDSTooltipPlacement {
  Top = "top",
  TopLeft = "top left",
  TopRight = "top right",
  Right = "right",
  Bottom = "bottom",
  BottomLeft = "bottom left",
  BottomRight = "bottom right",
  Left = "left",
}

export type IMDSTooltipProps = {
  config?: MDSTooltipConfig;
  /**
   * Disables the tooltip while keeping the trigger wrapper mounted. Prefer this
   * over conditionally rendering `MDSTooltip` when the wrapped subtree must not
   * remount as the tooltip toggles on/off (e.g. it owns stateful children keyed
   * by id).
   */
  isDisabled?: boolean;
  children: React.ReactNode;
};

export type MDSTooltipConfig = {
  label: React.ReactNode;
  shortcutLabel?: string;
  shortcutHotkey?: Hotkey;
  placement: MDSTooltipPlacement;
  offset?: number;
  delaySeconds?: number;
};
